import { useCallback } from 'react';
import { useTrackEvent } from '~/contexts/SearchAnalyticsContext';

export enum OpenSource {
  GreatDeal = 'Great deal tag',
  EvTax = 'EV credit pill',
  NewPrice = 'New price tag',
  Terms = 'terms'
}

export default function useSendOpenModalEvent() {
  const trackEvent = useTrackEvent();

  return useCallback(
    (clickedSource: OpenSource) => {
      trackEvent('open-result-tile-modal', {
        clickedSource
      });
    },
    [trackEvent]
  );
}
